<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1>Acknowledgements</h1>
<p>The first three chapters of this novel, in a somewhat different form, appeared in <em>Be Untexed</em>, a Burma-based online journal of new writings and visual arts. For this, I thank the editors of the journal.</p>
<p>My special thanks go to my niece, Theint, for helping me financially to finish and publish this book, and to artist Maung Di for encouraging me to publish this book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?31c6d3b9